import { render, staticRenderFns } from "./DashboardGrowth.vue?vue&type=template&id=05a22ba6&scoped=true"
import script from "./DashboardGrowth.vue?vue&type=script&lang=ts"
export * from "./DashboardGrowth.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05a22ba6",
  null
  
)

export default component.exports